import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';
import CartButton from '@material-ui/icons/ShoppingCart';
import CartContainer from 'features/Cart';
import compose from 'recompose/compose';
import Customer from 'models/Customer';
import Drawer from '@material-ui/core/Drawer';
import ErrorBoundary from 'shared/components/ErrorBoundary';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { SHOPPING_CART, WISH_LIST } from 'redux/domain/Cart/constants';
import { withStyles } from '@material-ui/core/styles';

// change theme later when material v1 upgrades
const styles = theme => ({
	root: {
		left: 'auto',
		right: 0,
		width: '100%',
		flex: '1 0 auto',
		height: '100vh',
		display: 'flex',
		position: 'fixed',
		overflowY: 'auto',
		flexDirection: 'column',
		color: theme.palette.text.primary,
		fontFamily: theme.typography.fontFamily,

		[theme.breakpoints.up('xs')]: {
			width: '100%',
		},
		[theme.breakpoints.up('sm')]: {
			width: '50%',
		},
		[theme.breakpoints.up('md')]: {
			width: '33%',
		},
		[theme.breakpoints.up('lg')]: {
			width: '25%',
		},
	},
	appbar: {
		height: 36,
	},
	badge: {
		backgroundColor: theme.palette.background.paper,
		color: theme.palette.text.primary,
		top: '0px',
		right: '0px',
	},
	badgeStyle: {
		padding: '0px 4px',
		marginRight: -6,
		marginTop: 0,
		top: 0,
	},
	leftDrawerLinks: {
		textTransform: 'uppercase',
	},
	shopbar: {
		zIndex: 0,
		fontSize: 16,
		marginTop: 10,
		height: 44,
		lineHeight: 2,
		color: theme.palette.getContrastText(theme.palette.primary.main),
	},
	shopTypography: {
		fontSize: 12,
	},
	tab: {
		height: 44,
		minHeight: 44,
		boxShadow: 'none',
	},
	tabTypography: {
		marginTop: 5,
		fontSize: 12,
		color: theme.palette.getContrastText(theme.palette.primary.main),
	},
	tabs: {
		// z-index was added here so the button ripple apears above the toolbar
		zIndex: 1100,
		borderBottomStyle: 'outset',
		borderBottomWidth: 'thin',
		backgroundColor: theme.palette.primary.main,
		height: 43,
		minHeight: 43,
	},
	toolbar: {
		zIndex: 0,
		minHeight: 54,
	},
});

class NavCartDrawer extends React.Component {
	constructor() {
		super();
		this.state = { openTabId: 1 };
		this.handleChange = this.handleChange.bind(this);
	}

	handleChange = (event, openTabId) => {
		this.setState({ openTabId });
	};

	render() {
		const {
			classes,
			customer,
			isCartDrawerOpen,
			toggleCartDrawer,
			shoppingCartQuantity,
			openEmailCart,
		} = this.props;
		const { openTabId } = this.state;
		return (
			<Drawer
				anchor="right"
				open={isCartDrawerOpen}
				onClose={toggleCartDrawer}
				PaperProps={{ className: classes.root }}
				keepMounted
			>
				<AppBar className={classes.appbar} position="static">
					<Toolbar className={classes.toolbar}>
						<Typography variant="h2" color="inherit" className={classes.shopbar}>
							Shopping Cart
						</Typography>
						<div style={{ margin: '-2px -10px 0px auto' }}>
							<Badge
								badgeContent={shoppingCartQuantity}
								className={classes.badgeStyle}
								classes={{ badge: classes.badge, colorPrimary: classes.colorPrimary }}
								color="primary"
							>
								<IconButton
									disableRipple
									color="inherit"
									onClick={toggleCartDrawer}
									style={{ backgroundColor: 'transparent' }}
								>
									<CartButton style={{ color: 'black' }} />
								</IconButton>
							</Badge>
						</div>
					</Toolbar>
				</AppBar>
				<ErrorBoundary>
					<Tabs
						value={openTabId}
						onChange={this.handleChange}
						className={classes.tabs}
						TabIndicatorProps={{ style: { backgroundColor: '#000000', height: 3 } }}
					>
						<Tab
							label={<Typography className={classes.tabTypography}>Idea Board</Typography>}
							TouchRippleProps={{ style: { color: '#ffffff' } }}
							className={classes.tab}
						/>
						<Tab
							label={<Typography className={classes.tabTypography}>Cart</Typography>}
							TouchRippleProps={{ style: { color: '#ffffff' } }}
							className={classes.tab}
						/>
					</Tabs>
					{customer.id &&
						openTabId === 0 && (
							<CartContainer
								customerId={customer.id}
								isGuest={customer.isGuest}
								cartType={WISH_LIST}
							/>
						)}
					{customer.id &&
						openTabId === 1 && (
							<CartContainer
								customerId={customer.id}
								isGuest={customer.isGuest}
								cartType={SHOPPING_CART}
								openEmailCart={openEmailCart}
							/>
						)}
				</ErrorBoundary>
			</Drawer>
		);
	}
}

NavCartDrawer.propTypes = {
	classes: PropTypes.shape({
		root: PropTypes.string,
		appbar: PropTypes.string,
		badge: PropTypes.string,
		badgeStyle: PropTypes.string,
		colorPrimary: PropTypes.string,
		shopbar: PropTypes.string,
		shopTypography: PropTypes.string,
		tabs: PropTypes.string,
		tab: PropTypes.string,
		tabTypography: PropTypes.string,
		toolbar: PropTypes.string,
	}).isRequired,
	customer: PropTypes.instanceOf(Customer).isRequired,
	isCartDrawerOpen: PropTypes.bool,
	toggleCartDrawer: PropTypes.func.isRequired,
	shoppingCartQuantity: PropTypes.number.isRequired,
	openEmailCart: PropTypes.func.isRequired,
};

NavCartDrawer.defaultProps = {
	isCartDrawerOpen: false,
};

// make state available via props
const mapStateToProps = state => {
	const shoppingCartQuantity = state.cart.get('shoppingCartQuantity');
	return {
		shoppingCartQuantity,
	};
};
export default compose(
	withStyles(styles, { name: 'NavCartDrawer' }),
	connect(mapStateToProps, null),
)(NavCartDrawer);
